/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CreateUpdateNotificationKind = "INVESTMENT" | "PITCH_PLANET" | "UGC" | "%future added value";
export type CreateNotificationInput = {
    readonly clientMutationId: string;
    readonly notificationKind: CreateUpdateNotificationKind;
    readonly email?: string | null;
    readonly meta?: NotificationMetaDataInput | null;
};
export type NotificationMetaDataInput = {
    readonly entity?: string | null;
    readonly pitchVideo?: string | null;
    readonly date?: string | null;
    readonly person?: string | null;
    readonly description?: boolean | null;
};
export type createRadivisionNotificationMutationVariables = {
    readonly input: CreateNotificationInput;
};
export type createRadivisionNotificationMutationResponse = {
    readonly createRadivisionNotification: {
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly hasErrors: boolean | null;
        readonly notification: {
            readonly id: string;
            readonly created: unknown | null;
            readonly status: string | null;
            readonly title: string | null;
        } | null;
    } | null;
};
export type createRadivisionNotificationMutation = {
    readonly response: createRadivisionNotificationMutationResponse;
    readonly variables: createRadivisionNotificationMutationVariables;
};



/*
mutation createRadivisionNotificationMutation(
  $input: CreateNotificationInput!
) {
  createRadivisionNotification(input: $input) {
    errors {
      id
      location
    }
    hasErrors
    notification {
      id
      created
      status
      title
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateNotificationInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createRadivisionNotification",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateUpdateNotificationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "notification",
        "storageKey": null,
        "args": null,
        "concreteType": "Notification",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "created",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createRadivisionNotificationMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "createRadivisionNotificationMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "createRadivisionNotificationMutation",
    "id": null,
    "text": "mutation createRadivisionNotificationMutation(\n  $input: CreateNotificationInput!\n) {\n  createRadivisionNotification(input: $input) {\n    errors {\n      id\n      location\n    }\n    hasErrors\n    notification {\n      id\n      created\n      status\n      title\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '0609129e0c945388f535672b41cda8a3';
export default node;
